import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation MFATOTPDeleteUser($userId: ID!) {
    mfaTotpDeleteUser(userId: $userId)
  }
`

export const mfaTotpDeleteUserKey = getQueryNames(mutation)[0]

export default mutation
